import React, { useEffect, useState } from "react";
import {
  createParametrageCaisse,
  getParametrageCaisse,
  updateParametragesCaisse,
} from "../Services/ParametrageApi";
import { useOrganisations } from "../Auth/useOrganisations";
import Swal from "sweetalert2";

const ParametragesCaisse = () => {
  const [parametrage, setParametrage] = useState();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [form, setForm] = useState({
    products_grouping: false,
    timbre: 0,
    timbreFacture: 0,
    TableRequired: false,
    messagePromo: "",
    doubleRole: false,
    clotureAllFund: false,
    menuOrderConfirmation: false,
    defaultCashInput: false,
    defaultFondClotureInput: false,
    chargementProduits: false,
    impressionTicket: true,
  });

  const [
    organisations,
    setOrganisations,
    usedOrganisations,
    setUsedOrganisations,
  ] = useOrganisations();
  useEffect(() => {
    if (!usedOrganisations) return;

    setLoading(true);

    getParametrageCaisse(usedOrganisations)
      .then((res) => {
        if (res.data.success && res.data.data) {
          setParametrage(res.data.data);
          setForm({
            products_grouping: res.data.data.products_grouping,
            timbre: res.data.data.timbre,
            timbreFacture: res.data.data.timbreFacture,
            TableRequired: res.data.data.TableRequired,
            messagePromo: res.data.data.messagePromo,
            doubleRole: res.data.data.doubleRole,
            clotureAllFund: res.data.data.clotureAllFund,
            menuOrderConfirmation: res.data.data.menuOrderConfirmation,
            defaultCashInput: res.data.data.defaultCashInput,
            defaultFondClotureInput: res.data.data.defaultFondClotureInput,
            chargementProduits: res.data.data.chargementProduits,
            impressionTicket: res.data.data.impressionTicket !== false,
          });
        } else {
          setParametrage(null);
        }
      })
      .finally(() => setLoading(false));
  }, [usedOrganisations]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      if (parametrage?.id) {
        // 🔁 UPDATE
        await updateParametragesCaisse(parametrage.id, { ...form });
        Swal.fire({
          icon: "success",
          title: "Paramètres mis à jour",
          text: "Les paramètres ont été mis à jour avec succès !",
          confirmButtonColor: "#4f46e5",
        });
      } else {
        // ➕ CREATE
        await createParametrageCaisse({
          ...form,
          organisation_id: usedOrganisations,
        });
        Swal.fire({
          icon: "success",
          title: "Paramètres créés",
          text: "Les paramètres ont été enregistrés avec succès !",
          confirmButtonColor: "#4f46e5",
        });
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Erreur",
        text: "Une erreur est survenue lors de l’enregistrement.",
        confirmButtonColor: "#e11d48",
      });
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <p>Chargement...</p>;
  return (
    <div className="parametrages-caisse">
      <div className="settings-card">
        <h3 className="settings-title">Paramétrages Caisse</h3>

        <form onSubmit={handleSubmit}>
          {/* SWITCHES */}
          <div className="switch-grid">
            <Switch
              label="Chargement de produits dans caisse"
              name="chargementProduits"
              checked={form.chargementProduits}
              onChange={handleChange}
            />
            <Switch
              label="Groupement des produits"
              name="products_grouping"
              checked={form.products_grouping}
              onChange={handleChange}
            />
            <Switch
              label="Table obligatoire"
              name="TableRequired"
              checked={form.TableRequired}
              onChange={handleChange}
            />
            <Switch
              label="Confirmation des commades via menu code qr"
              name="menuOrderConfirmation"
              checked={form.menuOrderConfirmation}
              onChange={handleChange}
            />
            <Switch
              label="Double rôle (vendeur / caissier)"
              name="doubleRole"
              checked={form.doubleRole}
              onChange={handleChange}
            />
            <Switch
              label="Clôture tous les fonds"
              name="clotureAllFund"
              checked={form.clotureAllFund}
              onChange={handleChange}
            />
            <Switch
              label="Montant espéces saisi par default"
              name="defaultCashInput"
              checked={form.defaultCashInput}
              onChange={handleChange}
            />
            <Switch
              label="Fond de caisse final saisi par default"
              name="defaultFondClotureInput"
              checked={form.defaultFondClotureInput}
              onChange={handleChange}
            />
            <Switch
              label="Impression ticket (sinon affiché à l'écran)"
              name="impressionTicket"
              checked={form.impressionTicket}
              onChange={handleChange}
            />
          </div>

          {/* NUMERIC INPUTS */}
          <div className="input-grid">
            <Input
              label="Timbre"
              name="timbre"
              type="number"
              value={form.timbre}
              onChange={handleChange}
            />
            <Input
              label="Timbre facture"
              name="timbreFacture"
              type="number"
              value={form.timbreFacture}
              onChange={handleChange}
            />
          </div>

          {/* TEXTAREA */}
          <div className="textarea-group">
            <label>Message promotionnel</label>
            <textarea
              name="messagePromo"
              value={form.messagePromo}
              onChange={handleChange}
            />
          </div>

          {/* SAVE BUTTON */}
          <button type="submit" className="save-btn" disabled={saving}>
            {saving ? "Enregistrement…" : "Enregistrer"}
          </button>
        </form>
      </div>
    </div>
  );
};

// SWITCH COMPONENT
const Switch = ({ label, ...props }) => (
  <label className="switch-row">
    <span>{label}</span>
    <label className="switch">
      <input type="checkbox" {...props} />
      <span className="slider" />
    </label>
  </label>
);

// INPUT COMPONENT
const Input = ({ label, ...props }) => (
  <div className="input-group">
    <label>{label}</label>
    <input {...props} />
  </div>
);
export default ParametragesCaisse;
